import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Microwave = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M12.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-1.167.5a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0zM12.5 8.667a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-1.167.5a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0zM2.333 4.667c0-.184.149-.333.333-.333h7c.184 0 .333.149.333.333V10a.333.333 0 0 1-.333.333h-7A.333.333 0 0 1 2.333 10V4.667zM3 5v4.667h6.333V5H3z" />
      <path d="M1.667 2.333A.667.667 0 0 0 1 3v8.667c0 .368.298.667.667.667h12.667a.667.667 0 0 0 .667-.667V3a.667.667 0 0 0-.667-.667H1.667zM.333 3c0-.736.597-1.333 1.333-1.333h12.667c.736 0 1.333.597 1.333 1.333v8.667c0 .736-.597 1.333-1.333 1.333H1.666a1.333 1.333 0 0 1-1.333-1.333V3z" />
      <path d="M2.667 12.333c.184 0 .333.149.333.333v1.333a.333.333 0 1 1-.666 0v-1.333c0-.184.149-.333.333-.333zM13.333 12.333c.184 0 .333.149.333.333v1.333a.333.333 0 1 1-.666 0v-1.333c0-.184.149-.333.333-.333z" />
    </svg>
  );
};

Microwave.category = 'product-category';

Microwave.displayName = 'Microwave';
